// 年表計算區。
export const getters = {
  // 輸入無效代號或 call API 伺服器失效，接收錯誤提示訊息。
  errorMessageWithReportRatioYear: state => state.errorMessage,

  // ------------------ 年表四個表格主標題區格式 ------------------

  headlinesOfReportRatioYear: (
    {
      reportRatioYear: [
        { stock_symbol: stockSymbol, company_name: companyName }
      ]
    },
    { map2Character }
  ) => ({
    stockSymbol,
    companyName,
    liquiditiesYear: map2Character("liquidities"), // 償債能力表
    returnOnInvestmentsYear: map2Character("return_on_investments"), // 獲利能力表
    perShareRatiosYear: map2Character("per_share_ratios"), // 每股比例表
    operatingPerformancesYear: map2Character("operating_performances") // 經營能力表
  }),

  // ------------------ 償債能力表_年 ------------------

  // unpack 表格欄位基本資料。
  liquiditiesYear: ({ reportRatioYear: [{ year_liquidities }] }) =>
    year_liquidities,

  // 共用 rootGetters => fieldsOfYear。
  // 取得償債能力表_年 Period 期別標題與 labels 種類次標題。
  // fieldsOfLiquiditiesYear: (state, { fieldsOfYear, liquiditiesYear }) =>
  //   fieldsOfYear(liquiditiesYear),

  // 併整 bootstrap-vue items 格式與標題英翻中 => formatOfReportYear。
  itemsOfLiquiditiesYear: (
    state,
    { liquiditiesYear, formatOfReportRatioYear }
  ) => formatOfReportRatioYear(liquiditiesYear),

  // 共用 rootGetters => layerOfTableArea。
  // 取得標題欄位 order 階層排列。
  layerOfLiquiditiesYear: (
    state,
    { itemsOfLiquiditiesYear, layerOfTableArea }
  ) => layerOfTableArea(itemsOfLiquiditiesYear),

  // ------------------ 獲利能力表_年 ------------------

  returnOnInvestmentsYear: ({
    reportRatioYear: [{ year_return_on_investments }]
  }) => year_return_on_investments,

  // fieldsOfReturnOnInvestmentsYear: (
  //   state,
  //   { fieldsOfYear, returnOnInvestmentsYear }
  // ) => fieldsOfYear(returnOnInvestmentsYear),

  itemsOfReturnOnInvestmentsYear: (
    state,
    { returnOnInvestmentsYear, formatOfReportRatioYear }
  ) => formatOfReportRatioYear(returnOnInvestmentsYear),

  // ------------------ 每股比例表_年 ------------------

  perShareRatiosYear: ({ reportRatioYear: [{ year_per_share_ratios }] }) =>
    year_per_share_ratios,

  // fieldsOfPerShareRatiosYear: (state, { fieldsOfYear, perShareRatiosYear }) =>
  //   fieldsOfYear(perShareRatiosYear),

  itemsOfPerShareRatiosYear: (
    state,
    { perShareRatiosYear, formatOfReportRatioYear }
  ) => formatOfReportRatioYear(perShareRatiosYear),

  // ------------------ 經營能力表_年 ------------------

  operatingPerformancesYear: ({
    reportRatioYear: [{ year_operating_performances }]
  }) => year_operating_performances,

  // fieldsOfOperatingPerformancesYear: (
  //   state,
  //   { fieldsOfYear, operatingPerformancesYear }
  // ) => fieldsOfYear(operatingPerformancesYear),

  itemsOfOperatingPerformancesYear: (
    state,
    { operatingPerformancesYear, formatOfReportRatioYear }
  ) =>
    // 第二參數判斷無需進行百分比轉換，此整區單純顯示天數。
    formatOfReportRatioYear(operatingPerformancesYear, "days"),

  // ------------------ 複用格式轉換區 ------------------

  // 全區併整 bootstrap-vue table => items 支援格式和英翻中小標題。
  formatOfReportRatioYear: (state, { map2Character, number2Percentage }) => (
    dataSets,
    status
  ) => {
    // 取出所有 key 名，以小標題序列作為基底所構成的陣列，拿取 (array.length) 當作每次迴圈總數基準值。
    // 將 year 移除，主因橫列無需顯示 year 標題列。
    const fields = Object.keys(dataSets.slice().shift()).filter(
      field => field !== "year"
    );
    const data = fields.map(field => {
      // dataSets 長度為 8，代表每次皆會跑完八筆物件資料 2019, 2018, ...。
      return dataSets.reduce((res, current) => {
        res = { ...res };
        res.subTitle = map2Character(field);

        if (
          status === "days" ||
          field === "EBIDTA_per_share" ||
          field === "EPS"
        ) {
          // 參數帶有狀態 days 或特例=> 每股 EBIDTA(元) 只需直接顯示，無需轉換格式。
          res[current.year] = current[field];
        } else if (current[field] === null) {
          // 當值是 null 要轉成 NA
          res[current.year] = "NA";
        } else {
          res[current.year] = number2Percentage(current, field);
        }

        return res;
      }, {});
    });
    return data;
  }
};
